import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventType } from '../../models';
@Component({
  selector: 'hypenation-tickets-filtering-options',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './filtering-options.component.html',
  styleUrl: './filtering-options.component.css',
})
export class FilteringOptionsComponent implements AfterViewInit {
  @ViewChild('scrollableContainer') scrollableContainer!: ElementRef;
  
  @Input() eventsTypes : EventType[] = []
  @Output() selectEventCategory : EventEmitter<EventType> = new EventEmitter<EventType>;
  @Output() clearFilter : EventEmitter<void> = new EventEmitter<void>;


  selectedEventType! : string;
  canScrollLeft = false;
  canScrollRight = true;

  ngAfterViewInit(): void {
    this.checkScrollPosition();
  }

  

  selectCategory(eventType: EventType) {
    this.selectedEventType = eventType.uid;
    this.selectEventCategory.emit(eventType);
  }

  clearSelection() {
    this.selectedEventType = '';
    this.clearFilter.emit();
  }

  scrollLeft() {
    this.scrollableContainer.nativeElement.scrollBy({
      left: -200,
      behavior: 'smooth',
    });
  }

  scrollRight() {
    this.scrollableContainer.nativeElement.scrollBy({
      left: 200,
      behavior: 'smooth',
    });
  }

  checkScrollPosition() {
    const scrollElement = this.scrollableContainer.nativeElement;
    this.canScrollLeft = scrollElement.scrollLeft > 0;
    this.canScrollRight =
      scrollElement.scrollWidth > scrollElement.clientWidth &&
      scrollElement.scrollLeft <
        scrollElement.scrollWidth - scrollElement.clientWidth;
  }
}
